export default "__VITE_ASSET__BGObz0rH__"